var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-easy-light-box',{attrs:{"loop":"","visible":_vm.lightBoxVisible,"imgs":_vm.lightBoxImages,"index":_vm.lightBoxIndex},on:{"hide":_vm.hideLightBox}})}
var staticRenderFns = []

export { render, staticRenderFns }